import { render, staticRenderFns } from "./Wde.vue?vue&type=template&id=b97f3a0c&scoped=true"
import script from "./Wde.vue?vue&type=script&lang=js"
export * from "./Wde.vue?vue&type=script&lang=js"
import style0 from "./Wde.vue?vue&type=style&index=0&id=b97f3a0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97f3a0c",
  null
  
)

export default component.exports